import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import { FaEye } from 'react-icons/fa';
import Button from '../../components/buttons/Button';
import { Link } from 'react-router-dom';
import { patchInvoices } from '../../services/clinic/invoice';
import { toast } from 'react-toastify';
import ViewPdfModalFromComponent from '../../components/PdfViewer/ViewPdfModalFromComponent';
import { getUserName, getUserRole } from '../../utils/localStoarege';
import { getMedicineInvoiceApi, getMedicineStats } from '../../services/clinic/medicine_invoice';
import { formatDateTime } from '../../utils/FormatDateTime';
import ViewMedicinePdfModalFromComponent from '../../components/PdfViewer/ViewMedicinePdfModalFromComponent';
import { IoMdRefresh } from 'react-icons/io';
import SearchBar from '../../components/searchBar/SearchBar';
import Dropdown from '../../components/inputFields/DropDown';


function MedicineInvoice() {
    const [cardData, setCardData] = useState([
        {
            title: "--",
            count: "--",
        },
        {
            title: "--",
            count: "--",
        },
    ]);

    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "ID", key: "id" },
        { label: "Name", key: "name" },
        { label: "Amount", key: "amount" },
        { label: "Payment Mode", key: "mode" },
        { label: "Phone", key: "phone" },
        { label: "Date", key: "created_at" },
        { label: "Action", key: "action" },
        { label: "Transaction Number", key: "transaction_number" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [pdfToDisplay, setPdfToDisplay] = useState({});
    const [searchText, setSearchText] = useState("");
    const isMedical = getUserRole() === 'medical';
    const [selectedCenter, setSelectedCenter] = useState(isMedical ? "Indore" : getUserName());

    const centerOptions = [
        { label: "Ahemdabad", value: "Ahemdabad" },
        { label: "Banglore", value: "Banglore" },
        { label: "Delhi", value: "Delhi" },
        { label: "Hyderabad", value: "Hyderabad" },
        { label: "Indore", value: "Indore" },
        { label: "Mumbai", value: "Mumbai" },
        { label: "Nagpur", value: "Nagpur" },
        { label: "Pune", value: "Pune" },
        { label: "Raipur", value: "Raipur" },
        { label: "Surat", value: "Surat" },
        { label: "Vadodara", value: "Vadodara" },
    ];


    const pageSize = 100;

    const fetchData = async (query, centerName) => {
        setLoading(true);
        try {
            const center = isMedical ? (centerName || selectedCenter) : getUserName();
            let res = await getMedicineInvoiceApi(query || "", center);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch Invoice");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Invoice:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchStats = async (centerName) => {
        try {
            const center = isMedical ? centerName : getUserName();
            let res = await getMedicineStats(center);
            if (res.status === 200) {
                setCardData([
                    {
                        title: "Total Amount Received",
                        count: res.data.total_amount_received,
                    },
                    {
                        title: "Total Invoices Generated",
                        count: res.data.total_invoices_generated,
                    },
                    {
                        title: "Online Paid",
                        count: res.data.online_paid,
                    },
                    {
                        title: "Cash Paid",
                        count: res.data.cash_paid,
                    },

                ]);
            } else {
                toast.error("Unable to fetch stats");
            }
        } catch (error) {
            console.error("Error fetching Stats:", error);
        }
    };

    useEffect(() => {
        const initCenter = isMedical ? selectedCenter : getUserName();
        fetchData("", initCenter);
        fetchStats(initCenter);
    }, []);

    const handleCenterChange = (value) => {
        setSelectedCenter(value);
        setSearchText("");
        fetchData("", value);
        fetchStats(value);
    };


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const openPdfModal = (values) => {
        setPdfToDisplay(values);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleApprovalChange = async (id, value) => {
        try {
            let res = await patchInvoices(id, value);
            if (res.status === 200) {
            } else {
                toast.error("Error Updating Status");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Machines:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData("&search=" + query, selectedCenter);
    };

    const resetSearch = () => {
        setSearchText("");
        fetchData("", selectedCenter);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home' },
            { name: 'Medicine Invoice' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Invoice"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"Invoice"} />
            <div className="flex flex-row items-center gap-3">
                {isMedical && (
                    <div className="w-48">
                        <Dropdown
                            placeholder={selectedCenter}
                            options={centerOptions}
                            onChange={handleCenterChange}
                            needSearch={true}
                        />
                    </div>
                )}
                <Link to={isMedical ? '/medical/invoice-medicine/add' : '/invoice-medicine/add'}>
                    <Button children={"Add Invoice"} className="bg-primary text-white rounded-lg" />
                </Link>
            </div>
        </div>
        <div className="flex flex-row items-center gap-3">
            <div className="md:w-[30%] lg:w-[20%] self-end mb-2">
                <SearchBar placeholder="Search Patients..." value={searchText} onSearch={handleSearch} />
            </div>
            {
                searchText !== "" ?
                    <IoMdRefresh size={23} className='text-primary cursor-pointer' onClick={resetSearch} /> : <></>
            }
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                id: <p>{index + 1}</p>, // Display sequential numbers starting from 1
                                name: <p>{item.name}</p>,
                                amount: <p>{item.amount}</p>,
                                mode: <p>{item.mode}</p>,
                                phone: <p>{item.phone}</p>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                transaction_number: <p>{item.transaction_number}</p>,
                                action: (
                                    <span
                                        className="cursor-pointer self-center items-center justify-center"
                                        onClick={() => openPdfModal(item)}
                                    >
                                        <FaEye color="green" size={20} />
                                    </span>
                                ),
                            }
                        ))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
        <ViewMedicinePdfModalFromComponent contentLabel={"PDF"} isOpen={modalIsOpen} onRequestClose={closeModal} values={pdfToDisplay} />
    </>);
}

export default MedicineInvoice;